// Category → hero video map (used by ServiceDetail to play the category video in the hero)
export const categoryMedia: Record<string, { media: string; mediaType: 'video' | 'image' }> = {
  hair: {
    media: 'https://cdn.shopify.com/videos/c/o/v/0ec560a3c566433ea31b13dd7201f211.webm',
    mediaType: 'video',
  },
  face: {
    media: 'https://cdn.shopify.com/videos/c/o/v/7c179f614d44422e9bb9ecfdc4ceb037.webm',
    mediaType: 'video',
  },
  advanced: {
    media: 'https://cdn.shopify.com/videos/c/o/v/ee9067a524544e8f8374b5dcaefed763.webm',
    mediaType: 'video',
  },
  holistic: {
    media: 'https://cdn.shopify.com/videos/c/o/v/7c179f614d44422e9bb9ecfdc4ceb037.webm',
    mediaType: 'video',
  },
};

const generalAfter =
  'מומלץ להימנע מחשיפה לשמש במהלך השבוע הראשון לאחר הטיפול, להשתמש בקרם הגנה SPF 50+ מדי יום (גם בחורף וגם כשאין שמש), ולהימנע מפעילות ספורטיבית אינטנסיבית בשבוע הראשון.';

const generalRecommendations = [
  'הימנעי מחשיפת יתר לשמש',
  'הימנעי מגירויים כימיים',
  'הימנעי משחייה בבריכות',
  'הימנעי מעיסויים באזור המטופל',
  'הימנעי מטיפולי פילינג נוספים',
  'הימנעי משימוש בתכשירים המכילים חומצה',
];

const HAIR_VIDEO = 'https://cdn.shopify.com/videos/c/o/v/0ec560a3c566433ea31b13dd7201f211.webm';
const FACE_VIDEO = 'https://cdn.shopify.com/videos/c/o/v/7c179f614d44422e9bb9ecfdc4ceb037.webm';
const ADV_VIDEO = 'https://cdn.shopify.com/videos/c/o/v/ee9067a524544e8f8374b5dcaefed763.webm';

export const servicesData = [
  // ===================== HAIR & SCALP =====================,
  {
    id: "thai-scalp-massage",
    category: "hair",
    title: "עיסוי תאילנדי לקרקפת עם צמחי מרפא ערביים",
    subtitle: "Thai Scalp Therapy",
    tagline: "חיזוק שורשי השיער • המרצת צמיחה • איזון הקרקפת",
    description:
      "טיפול ייחודי המשלב טכניקות עיסוי תאילנדיות מסורתיות עם שמנים ותמציות מצמחים ערביים — לחיזוק השיער, איזון הקרקפת ושיפור זרימת הדם.",
    paragraphs: [
      "העיסוי התאילנדי לקרקפת הוא טיפול ייחודי המשלב בין טכניקות עיסוי מסורתיות לבין שימוש בשמנים ותמציות מצמחים ערביים בעלי תכונות מחזקות, מאזנות ומרגיעות. הטיפול נועד לשפר את זרימת הדם לקרקפת, להזין את שורשי השיער ולסייע בתהליך טבעי ובריא של צמיחה והתחדשות.",
      "הטיפול מתאים במיוחד לנשים וגברים הסובלים מנשירה, דלילות, שיער חלש, קרקפת מתוחה, סטרס או חוסר חיוניות של השיער. השילוב בין צמחי המרפא הערביים לבין טכניקות העיסוי התאילנדיות מעניק חוויית טיפול מרגיעה לצד תוצאות הנראות לעין לאורך זמן.",
    ],
    benefits: [
      "המרצת זרימת הדם לקרקפת",
      "חיזוק שורשי השיער",
      "עידוד צמיחה טבעית",
      "שחרור מתחים וסטרס",
      "הזנת הקרקפת והשיער לעומק",
      "שיפור חיוניות וברק השיער",
    ],
    suitableFor:
      "לנשים וגברים הסובלים מנשירה, דלילות, שיער חלש, קרקפת מתוחה, סטרס או חוסר חיוניות של השיער.",
    beforeTreatment:
      "מומלץ להגיע עם שיער נקי ויבש. יש לעדכן את המטפלת על רגישויות, טיפולים תרופתיים או טיפולי שיער קודמים.",
    afterTreatment:
      "מומלץ להימנע מחפיפת ראש ביום הטיפול כדי לאפשר ספיגה מלאה של החומרים הפעילים, ולהקפיד על שתייה מרובה.",
    faq: [
      { q: "למי הטיפול מתאים?", a: "לסובלים מנשירה, דלילות, חולשת שיער, קרקפת מתוחה או סטרס — וכן לכל מי שמחפש חוויית פינוק עמוקה לקרקפת." },
      { q: "תוך כמה זמן רואים תוצאות?", a: "תחושת הקלה והרפיה מורגשת מיד. שיפור בחיוניות השיער ובהפחתת נשירה נראה לרוב לאחר מספר טיפולים." },
      { q: "מה כדאי לעשות אחרי הטיפול?", a: "להימנע מחפיפת ראש ביום הטיפול ולשמור על קרקפת רגועה ללא מוצרי עיצוב אגרסיביים." },
      { q: "באיזו תדירות מומלץ?", a: "סדרת טיפולים אחת לשבוע או שבועיים, ולאחר מכן טיפול תחזוקה אחת לחודש." },
    ],
    media: HAIR_VIDEO,
    mediaType: 'video',
    price: "₪320",
    duration: "60 דק׳",
  },
  {
    id: "dandruff-balance",
    category: "hair",
    title: "טיפול טבעי בקשקשים ואיזון הקרקפת",
    subtitle: "Scalp Balance",
    tagline: "הרגעת גירויים • ניקוי עמוק • איזון שומניות",
    description:
      "טיפול מקצועי המבוסס על צמחי מרפא ערביים אנטי־בקטריאליים ואנטי־דלקתיים — לטיפול בקשקשים, גירויים, אדמומיות ושומניות יתר בקרקפת.",
    paragraphs: [
      "טיפול מקצועי המבוסס על צמחי מרפא ערביים בעלי תכונות אנטי־בקטריאליות ואנטי־דלקתיות, המיועד לטיפול בקשקשים, גירויים, אדמומיות ושומניות יתר בקרקפת. הטיפול מתמקד באיזון הקרקפת וטיפול בגורם הבעיה ולא רק בסימפטומים החיצוניים.",
      "הטיפול כולל ניקוי יסודי ועדין של הקרקפת, שימוש בתמציות ושמנים פעילים ועיסוי המשפר את זרימת הדם ואת ספיגת הרכיבים הפעילים.",
    ],
    benefits: [
      "הפחתת קשקשים וגרד",
      "הרגעת אדמומיות וגירויים",
      "איזון שומניות הקרקפת",
      "שיפור סביבת הקרקפת לצמיחה בריאה",
      "תחושת ניקיון ורעננות",
    ],
    suitableFor:
      "לסובלים מקשקשים, גרד, אדמומיות, גירויים בקרקפת או שומניות יתר.",
    beforeTreatment:
      "מומלץ להימנע מצביעת שיער או טיפולים כימיים בשבוע שלפני הטיפול. יש לעדכן את המטפלת על מוצרים בהם נעשה שימוש קבוע.",
    afterTreatment:
      "שימוש בשמפו עדין ללא סולפטים בלבד בימים הראשונים, והימנעות ממוצרי עיצוב כימיים או חום גבוה.",
    faq: [
      { q: "תוך כמה טיפולים רואים שיפור?", a: "שיפור ראשוני בגרד ובאדמומיות מורגש כבר מהטיפול הראשון, איזון מלא דורש לרוב 3–5 טיפולים." },
      { q: "האם הטיפול מתאים לקרקפת רגישה?", a: "כן. הטיפול מבוצע בחומרים טבעיים עדינים ומותאם אישית לרגישות הקרקפת." },
      { q: "מה ההמלצה לתחזוקה?", a: "שגרת טיפוח ביתית מותאמת תינתן בסיום הטיפול, וכן טיפול תחזוקה תקופתי במרפאה." },
      { q: "האם אפשר לחפוף ראש מיד אחרי?", a: "מומלץ להמתין לפחות 24 שעות לפני חפיפת ראש כדי לאפשר ספיגה מלאה של החומרים." },
    ],
    media: HAIR_VIDEO,
    mediaType: 'video',
    price: "₪290",
    duration: "60 דק׳",
  },
  {
    id: "scalp-hair-restoration",
    category: "hair",
    title: "טיפולי שיקום לקרקפת ולשיער",
    subtitle: "Scalp & Hair Restoration",
    tagline: "טיפול מותאם אישית לנשירה, חולשה ושיער פגום",
    description:
      "טיפולי שיקום המשלבים צמחי מרפא ערביים, חומרים פעילים וטכנולוגיות מתקדמות — לשיפור עמוק של בריאות הקרקפת והשיער, בהתאמה אישית.",
    paragraphs: [
      "טיפולי השיקום לקרקפת ולשיער משלבים צמחי מרפא ערביים, חומרים פעילים וטכנולוגיות טיפול מתקדמות במטרה לשפר את בריאות הקרקפת והשיער באופן עמוק ויסודי. הטיפול מותאם אישית לאחר אבחון מקצועי הכולל בדיקת מצב הקרקפת, סוג השיער ורמת הנשירה.",
      "הטיפול מתאים למצבים של נשירה, שיער חלש ודליל, שומניות יתר, יובש קיצוני או שיער פגום לאחר צבעים והחלקות.",
    ],
    benefits: [
      "התאמה אישית מלאה",
      "חיזוק שורשי השיער",
      "שיפור בריאות הקרקפת",
      "שיקום שיער פגום",
      "איזון שומניות ויובש",
      "שיפור מראה וברק השיער",
    ],
    suitableFor:
      "לסובלים מנשירה, דלילות, שומניות יתר, יובש קיצוני, או שיער פגום לאחר צבעים והחלקות.",
    beforeTreatment:
      "אבחון מקצועי של מצב הקרקפת והשיער. יש להגיע ללא מוצרי עיצוב ולעדכן את המטפלת על טיפולים קודמים.",
    afterTreatment:
      "הקפדה על שגרת טיפוח מותאמת אישית, שימוש במוצרים שהומלצו והגעה לטיפולי תחזוקה לפי התוכנית.",
    faq: [
      { q: "איך נקבעת תוכנית הטיפול?", a: "לאחר אבחון אישי הכולל בדיקת מצב הקרקפת, סוג השיער ורמת הנשירה — נבנית תוכנית מותאמת אישית." },
      { q: "כמה טיפולים נדרשים?", a: "בדרך כלל סדרה של 6–10 טיפולים בהתאם למצב ההתחלתי ולמטרות." },
      { q: "האם הטיפול מתאים לשיער צבוע?", a: "כן. הטיפול עוזר במיוחד לשיער שעבר תהליכים כימיים ופגום." },
      { q: "מתי נראים תוצאות?", a: "שיפור במרקם ובברק נראה כבר אחרי הטיפולים הראשונים. הפחתה משמעותית בנשירה לאחר 4–6 טיפולים." },
    ],
    media: HAIR_VIDEO,
    mediaType: 'video',
    price: "₪450",
    duration: "60 דק׳",
  },
  {
    id: "intensive-hair-repair",
    category: "hair",
    title: "שיקום אינטנסיבי לשיער מצמחי מרפא",
    subtitle: "Intensive Hair Repair",
    tagline: "החייאת שיער יבש, שרוף ופגום",
    description:
      "טיפול עומק אינטנסיבי לשיער שעבר נזקים — צביעות, החלקות, מכשירי חום ויובש קיצוני. החזרת לחות, ברק וגמישות מתוך סיב השערה.",
    paragraphs: [
      "טיפול עומק אינטנסיבי המיועד לשיער שעבר נזקים משמעותיים כתוצאה מצביעה, החלקות, שימוש במכשירי חום או יובש קיצוני. הטיפול מבוסס על שילוב בין רכיבים צמחיים פעילים, שמנים טבעיים וחומרים מחזקים החודרים לעומק סיב השערה ומשקמים אותו מבפנים.",
      "במהלך הטיפול מוחדרים לשיער רכיבי הזנה ולחות בריכוז גבוה במטרה לשפר את האלסטיות, להפחית שבירה וקצוות מפוצלים ולהחזיר לשיער את הברק, הרכות והחיוניות הטבעית שלו.",
    ],
    benefits: [
      "שיקום עמוק של סיב השערה",
      "החזרת לחות וברק טבעי",
      "שיפור גמישות וחוזק השיער",
      "הפחתת שבירה וקצוות מפוצלים",
      "ריכוך והחייאת השיער",
    ],
    suitableFor:
      "לשיער יבש, שרוף, פגום מצביעות, החלקות או חום — ולכל מי שמחפש החייאה אינטנסיבית.",
    beforeTreatment:
      "מומלץ לחפוף את השיער בשמפו עדין לפני ההגעה. יש לעדכן את המטפלת על תהליכים כימיים בחצי השנה האחרונה.",
    afterTreatment:
      "הימנעות משימוש במכשירי חום ב-48 השעות הראשונות, שימוש במסכת הזנה ביתית פעם בשבוע ושמירה על שגרת לחות.",
    faq: [
      { q: "תוך כמה זמן רואים תוצאות?", a: "הברק והרכות מורגשים מיד. שיקום עומק נראה לאחר 2–3 טיפולים." },
      { q: "האם מתאים לשיער שעבר החלקה?", a: "כן — הטיפול מומלץ במיוחד לאחר תהליכים כימיים ולהחזרת לחות לשיער." },
      { q: "באיזו תדירות מומלץ?", a: "אחת ל-3–4 שבועות בתחילה, ולאחר מכן טיפול תחזוקה אחת לחודש וחצי." },
      { q: "האם הטיפול נשטף?", a: "הטיפול נספג עמוק לתוך השערה. מומלץ לא לחפוף ראש בטווח של 24–48 שעות." },
    ],
    media: HAIR_VIDEO,
    mediaType: 'video',
    price: "₪400",
    duration: "60 דק׳",
  },
  {
    id: "organic-straightening",
    category: "hair",
    title: "החלקות אורגניות לשיער",
    subtitle: "Organic Straightening",
    tagline: "מראה חלק, טבעי ובריא ללא פגיעה בשיער",
    description:
      "פתרון מתקדם להפחתת נפח ופריז עם שמירה מלאה על בריאות השיער — מראה חלק, רך, מבריק וטבעי, בהתאמה אישית לסוג השיער.",
    paragraphs: [
      "החלקות אורגניות הן פתרון מתקדם לנשים המעוניינות להפחית נפח ופריז, לקבל מראה חלק ומטופח יותר ולשמור במקביל על בריאות השיער. בניגוד להחלקות אגרסיביות, הטיפול מבוסס על רכיבים עדינים יותר הפועלים בצורה מאוזנת על השיער ומעניקים לו מראה טבעי, רך ומבריק.",
      "הטיפול מותאם באופן אישי לסוג השיער ומאפשר להגיע לתוצאה חלקה וטבעית תוך שמירה על תחושת תנועה, גמישות ובריאות של השיער.",
    ],
    benefits: [
      "מראה חלק וטבעי",
      "הפחתת נפח ופריז",
      "שמירה על בריאות השיער",
      "ברק ורכות",
      "התאמה אישית מלאה",
    ],
    suitableFor:
      "לכל מי שמעוניינת להפחית פריז ונפח, לקבל מראה חלק וטבעי תוך שמירה על בריאות השיער.",
    beforeTreatment:
      "אבחון אישי של סוג השיער ומצבו. מומלץ להגיע עם שיער נקי וללא מוצרי עיצוב.",
    afterTreatment:
      "אין לחפוף ראש או לאסוף את השיער במשך 48–72 שעות לאחר הטיפול. שימוש בשמפו ללא סולפטים בלבד.",
    faq: [
      { q: "כמה זמן מחזיק הטיפול?", a: "בדרך כלל בין 3 ל-5 חודשים בהתאם לסוג השיער ולתחזוקה." },
      { q: "האם הטיפול בטוח?", a: "הטיפול מבוסס על רכיבים אורגניים עדינים ושומר על בריאות השיער." },
      { q: "האם מתאים לכל סוגי השיער?", a: "כן — הטיפול מותאם אישית לכל סוג שיער, מקודלים ועד שיער דק." },
      { q: "מתי אפשר לחפוף?", a: "יש להמתין 48–72 שעות לפני חפיפה ראשונה כדי לאפשר עיגון של החומרים." },
    ],
    media: HAIR_VIDEO,
    mediaType: 'video',
    price: "₪600",
    duration: "240 דק׳",
  },

  // ===================== FACE =====================,
  {
    id: "cold-renewal-peel",
    category: "face",
    title: "פילינג קר לחידוש והבהרת העור",
    subtitle: "Cold Renewal Peel",
    tagline: "טיפול עדין לשיפור מרקם, זוהר ואחידות העור",
    description:
      "פילינג קר הוא טיפול לחידוש העור ללא חימום משמעותי של הרקמה. הוא מתאים במיוחד לעור רגיש, עור עייף, עור עם פיגמנטציה קלה עד בינונית ולמי שרוצה חידוש עדין יחסית עם תוצאה נראית לעין.",
    paragraphs: [
      "טיפולי הפילינג בקליניקה הם טיפולים מתקדמים לחידוש העור, שיפור המרקם, הבהרת כתמים והענקת זוהר טבעי.",
      "הטיפול מותאם אישית לפי סוג העור, רמת הרגישות, מצב הפיגמנטציה והמטרה הטיפולית. בקליניקה ניתן לשלב בין סוגים שונים של פילינגים, בהם פילינג קר, פילינג ברק, פילינג צהוב ופילינג עמוק יותר לפי הצורך.",
      "מטרת הטיפול היא להסיר תאים מתים, לעודד התחדשות תאים, לשפר את אחידות גוון העור, להבהיר כתמים, לטשטש סימני עייפות ולהעניק לעור מראה חלק, בריא, אחיד וזוהר.",
      "טיפול לחידוש העור ללא חימום משמעותי של הרקמה, המותאם במיוחד לעור רגיש ולעור הזקוק לחידוש עדין.",
      "קריאה לפעולה: רוצה עור חלק, בהיר וזוהר יותר?",
    ],
    benefits: [
      "חידוש תאי עור",
      "הבהרת כתמים ופיגמנטציה",
      "שיפור מרקם העור",
      "הענקת Glow טבעי",
      "שיפור אחידות הגוון",
      "צמצום מראה נקבוביות",
      "רענון עור עייף",
      "עידוד ייצור קולגן",
      "התאמה אישית לפי מצב העור",
    ],
    suitableFor:
      "למטופלות עם עור עייף וחסר חיוניות. למי שסובלת מפיגמנטציה וכתמי שמש. למי שיש לה גוון עור לא אחיד. למי שסובלת מנקבוביות מורחבות. למי שיש סימני אקנה או פוסט אקנה שטחיים. למי שרוצה לחדש את העור. למי שרוצה מראה זוהר ובריא יותר. למי שמחפשת טיפול הבהרה עדין או עמוק, לפי מצב העור. למי שיש עור רגיש וצריכה התאמה מדויקת.",
    beforeTreatment:
      "יש להימנע מחשיפה מוגברת לשמש לפני הטיפול. חשוב לעדכן אם משתמשים ברטינול, חומצות פעילות או תרופות לעור. מומלץ להגיע עם עור נקי וללא איפור. במקרים של עור רגיש, יש לבצע התאמה עדינה יותר. לא מומלץ לבצע פילינג על עור מגורה מאוד, פצוע או לאחר שיזוף טרי.",
    afterTreatment:
      "יש להשתמש בקרם הגנה SPF 50 באופן קבוע. יש להימנע מחשיפה ישירה לשמש. ייתכן קילוף קל עד בינוני, בהתאם לסוג הפילינג. אין לקלף את העור באופן עצמאי. חשוב להקפיד על לחות והרגעת העור. יש להימנע מחומרים פעילים חזקים בימים הראשונים, לפי הנחיית רהאם.",
    faq: [
      { q: "האם רואים תוצאה כבר מהטיפול הראשון?", a: "כן. ברוב המקרים ניתן לראות שיפור בזוהר, במרקם ובחיוניות העור כבר לאחר הטיפול הראשון." },
      { q: "האם הפילינג מתאים לעור רגיש?", a: "כן, קיימים סוגי פילינג עדינים יותר שמתאימים גם לעור רגיש, לאחר אבחון והתאמה אישית." },
      { q: "כמה טיפולים צריך?", a: "בדרך כלל מומלץ לבצע סדרה של 3–6 טיפולים, בהתאם למצב העור והמטרה." },
      { q: "האם יש קילוף אחרי הטיפול?", a: "תלוי בסוג הפילינג. בפילינג עדין ייתכן שלא יהיה קילוף משמעותי, ובפילינג עמוק יותר ייתכן קילוף כחלק מתהליך ההתחדשות." },
    ],
    media: FACE_VIDEO,
    mediaType: 'video',
    price: "₪450",
    duration: "105 דק׳",
  },
  {
    id: "glow-peel",
    category: "face",
    title: "פילינג ברק / Glow",
    subtitle: "Glow Peel",
    tagline: "טיפול להענקת Glow טבעי ומראה רענן",
    description:
      "פילינג שמטרתו להעניק לעור מראה זוהר, קורן ורענן. מתאים במיוחד לפני אירועים, לעור עייף וחסר חיים, ולמי שרוצה תוצאה מהירה של רעננות וברק.",
    paragraphs: [
      "טיפולי הפילינג בקליניקה הם טיפולים מתקדמים לחידוש העור, שיפור המרקם, הבהרת כתמים והענקת זוהר טבעי.",
      "הטיפול מותאם אישית לפי סוג העור, רמת הרגישות, מצב הפיגמנטציה והמטרה הטיפולית. בקליניקה ניתן לשלב בין סוגים שונים של פילינגים, בהם פילינג קר, פילינג ברק, פילינג צהוב ופילינג עמוק יותר לפי הצורך.",
      "מטרת הטיפול היא להסיר תאים מתים, לעודד התחדשות תאים, לשפר את אחידות גוון העור, להבהיר כתמים, לטשטש סימני עייפות ולהעניק לעור מראה חלק, בריא, אחיד וזוהר.",
      "טיפול המיועד להעניק זוהר, רעננות וברק לעור, במיוחד לפני אירועים או כאשר העור נראה עייף וחסר חיוניות.",
      "קריאה לפעולה: רוצה עור חלק, בהיר וזוהר יותר?",
    ],
    benefits: [
      "חידוש תאי עור",
      "הבהרת כתמים ופיגמנטציה",
      "שיפור מרקם העור",
      "הענקת Glow טבעי",
      "שיפור אחידות הגוון",
      "צמצום מראה נקבוביות",
      "רענון עור עייף",
      "עידוד ייצור קולגן",
      "התאמה אישית לפי מצב העור",
    ],
    suitableFor:
      "למטופלות עם עור עייף וחסר חיוניות. למי שסובלת מפיגמנטציה וכתמי שמש. למי שיש לה גוון עור לא אחיד. למי שסובלת מנקבוביות מורחבות. למי שיש סימני אקנה או פוסט אקנה שטחיים. למי שרוצה לחדש את העור. למי שרוצה מראה זוהר ובריא יותר. למי שמחפשת טיפול הבהרה עדין או עמוק, לפי מצב העור. למי שיש עור רגיש וצריכה התאמה מדויקת.",
    beforeTreatment:
      "יש להימנע מחשיפה מוגברת לשמש לפני הטיפול. חשוב לעדכן אם משתמשים ברטינול, חומצות פעילות או תרופות לעור. מומלץ להגיע עם עור נקי וללא איפור. במקרים של עור רגיש, יש לבצע התאמה עדינה יותר. לא מומלץ לבצע פילינג על עור מגורה מאוד, פצוע או לאחר שיזוף טרי.",
    afterTreatment:
      "יש להשתמש בקרם הגנה SPF 50 באופן קבוע. יש להימנע מחשיפה ישירה לשמש. ייתכן קילוף קל עד בינוני, בהתאם לסוג הפילינג. אין לקלף את העור באופן עצמאי. חשוב להקפיד על לחות והרגעת העור. יש להימנע מחומרים פעילים חזקים בימים הראשונים, לפי הנחיית רהאם.",
    faq: [
      { q: "האם רואים תוצאה כבר מהטיפול הראשון?", a: "כן. ברוב המקרים ניתן לראות שיפור בזוהר, במרקם ובחיוניות העור כבר לאחר הטיפול הראשון." },
      { q: "האם הפילינג מתאים לעור רגיש?", a: "כן, קיימים סוגי פילינג עדינים יותר שמתאימים גם לעור רגיש, לאחר אבחון והתאמה אישית." },
      { q: "כמה טיפולים צריך?", a: "בדרך כלל מומלץ לבצע סדרה של 3–6 טיפולים, בהתאם למצב העור והמטרה." },
      { q: "האם יש קילוף אחרי הטיפול?", a: "תלוי בסוג הפילינג. בפילינג עדין ייתכן שלא יהיה קילוף משמעותי, ובפילינג עמוק יותר ייתכן קילוף כחלק מתהליך ההתחדשות." },
    ],
    media: FACE_VIDEO,
    mediaType: 'video',
    price: "₪380",
    duration: "105 דק׳",
  },
  {
    id: "yellow-peel",
    category: "face",
    title: "פילינג צהוב לחידוש עמוק של העור",
    subtitle: "Yellow Peel Advanced",
    tagline: "טיפול מתקדם לפיגמנטציה, סימני גיל ושיפור מרקם העור",
    description:
      "פילינג מתקדם לחידוש עמוק יותר של העור. מתאים לטיפול בפיגמנטציה, כתמי שמש, סימני גיל, קמטוטים, עור עייף ומרקם עור לא אחיד. הפילינג מעודד התחדשות תאים וייצור קולגן טבעי.",
    paragraphs: [
      "טיפולי הפילינג בקליניקה הם טיפולים מתקדמים לחידוש העור, שיפור המרקם, הבהרת כתמים והענקת זוהר טבעי.",
      "הטיפול מותאם אישית לפי סוג העור, רמת הרגישות, מצב הפיגמנטציה והמטרה הטיפולית. בקליניקה ניתן לשלב בין סוגים שונים של פילינגים, בהם פילינג קר, פילינג ברק, פילינג צהוב ופילינג עמוק יותר לפי הצורך.",
      "מטרת הטיפול היא להסיר תאים מתים, לעודד התחדשות תאים, לשפר את אחידות גוון העור, להבהיר כתמים, לטשטש סימני עייפות ולהעניק לעור מראה חלק, בריא, אחיד וזוהר.",
      "טיפול לחידוש עמוק יותר של העור, המיועד בין היתר לפיגמנטציה, סימני גיל, קמטוטים ומרקם עור לא אחיד.",
      "קריאה לפעולה: רוצה עור חלק, בהיר וזוהר יותר?",
    ],
    benefits: [
      "חידוש תאי עור",
      "הבהרת כתמים ופיגמנטציה",
      "שיפור מרקם העור",
      "הענקת Glow טבעי",
      "שיפור אחידות הגוון",
      "צמצום מראה נקבוביות",
      "רענון עור עייף",
      "עידוד ייצור קולגן",
      "התאמה אישית לפי מצב העור",
    ],
    suitableFor:
      "למטופלות עם עור עייף וחסר חיוניות. למי שסובלת מפיגמנטציה וכתמי שמש. למי שיש לה גוון עור לא אחיד. למי שסובלת מנקבוביות מורחבות. למי שיש סימני אקנה או פוסט אקנה שטחיים. למי שרוצה לחדש את העור. למי שרוצה מראה זוהר ובריא יותר. למי שמחפשת טיפול הבהרה עדין או עמוק, לפי מצב העור. למי שיש עור רגיש וצריכה התאמה מדויקת.",
    beforeTreatment:
      "יש להימנע מחשיפה מוגברת לשמש לפני הטיפול. חשוב לעדכן אם משתמשים ברטינול, חומצות פעילות או תרופות לעור. מומלץ להגיע עם עור נקי וללא איפור. במקרים של עור רגיש, יש לבצע התאמה עדינה יותר. לא מומלץ לבצע פילינג על עור מגורה מאוד, פצוע או לאחר שיזוף טרי.",
    afterTreatment:
      "יש להשתמש בקרם הגנה SPF 50 באופן קבוע. יש להימנע מחשיפה ישירה לשמש. ייתכן קילוף קל עד בינוני, בהתאם לסוג הפילינג. אין לקלף את העור באופן עצמאי. חשוב להקפיד על לחות והרגעת העור. יש להימנע מחומרים פעילים חזקים בימים הראשונים, לפי הנחיית רהאם.",
    faq: [
      { q: "האם רואים תוצאה כבר מהטיפול הראשון?", a: "כן. ברוב המקרים ניתן לראות שיפור בזוהר, במרקם ובחיוניות העור כבר לאחר הטיפול הראשון." },
      { q: "האם הפילינג מתאים לעור רגיש?", a: "כן, קיימים סוגי פילינג עדינים יותר שמתאימים גם לעור רגיש, לאחר אבחון והתאמה אישית." },
      { q: "כמה טיפולים צריך?", a: "בדרך כלל מומלץ לבצע סדרה של 3–6 טיפולים, בהתאם למצב העור והמטרה." },
      { q: "האם יש קילוף אחרי הטיפול?", a: "תלוי בסוג הפילינג. בפילינג עדין ייתכן שלא יהיה קילוף משמעותי, ובפילינג עמוק יותר ייתכן קילוף כחלק מתהליך ההתחדשות." },
    ],
    media: FACE_VIDEO,
    mediaType: 'video',
    price: "₪600",
    duration: "105 דק׳",
  },
  {
    id: "skin-firming-heat",
    category: "face",
    title: "מיצוק והרמת עור – חידוש קולגן באמצעות ידית חום",
    subtitle: null,
    tagline: "חידוש קולגן באמצעות ידית חום",
    description:
      "טיפול מיצוק והרמה הוא טיפול מתקדם המבוסס על חימום מבוקר של רקמת העור באמצעות ידית חום ייעודית. החימום פועל בשכבות העמוקות של העור ומעודד תהליך טבעי של ייצור קולגן ואלסטין.",
    paragraphs: [
      "הקולגן הוא אחד המרכיבים המרכזיים שאחראים על מראה עור מתוח, מוצק וצעיר. עם השנים קצב ייצור הקולגן יורד, והעור מתחיל לאבד מגמישות וממוצקות. הטיפול נועד לעודד את העור להתחדש מבפנים ולשפר את המראה הכללי בצורה טבעית ולא פולשנית.",
      "מדובר בטיפול לחידוש מאסיבי של העור, כאשר כבר מהטיפול הראשון ניתן לראות שיפור ראשוני במראה העור, וההשפעה ממשיכה להיבנות לאורך סדרת הטיפולים.",
      "תהליך טיפולי מומלץ: מומלצת סדרה של 4–5 טיפולים. כבר מהטיפול הראשון ניתן לראות תוצאה ראשונית. התוצאה משתפרת בהדרגה עם חידוש הקולגן.",
      "קריאה לפעולה: מרגישה שהעור איבד מוצקות? הגיע הזמן לחדש קולגן",
    ],
    benefits: [
      "מיצוק והרמה של העור",
      "עידוד ייצור קולגן טבעי",
      "שיפור גמישות העור",
      "שיפור מראה קמטוטים",
      "חידוש מאסיבי של רקמת העור",
      "מראה טבעי ורענן יותר",
      "ללא ניתוח",
      "ללא הזרקות",
      "תוצאה שנבנית מטיפול לטיפול",
    ],
    suitableFor:
      "למי שמרגישה שהעור איבד מוצקות. למי שסובלת מרפיון באזור הפנים. למי שרוצה לשפר את קו הלסת. למי שיש קמטוטים וקווים עדינים. למי שרוצה מראה מתוח ורענן יותר. למי שמחפשת טיפול ללא הזרקות וללא ניתוח. למי שמעוניינת בחידוש קולגן טבעי. למי שרוצה לשפר את מראה הצוואר והמחשוף.",
    beforeTreatment:
      "אין צורך בהכנה מיוחדת. מומלץ להגיע ללא איפור. חשוב לעדכן על מצבים רפואיים מיוחדים. חשוב לעדכן על שתלים, קוצב לב, טיפולים אסתטיים קודמים או רגישויות. הטיפול מותאם אישית לפי מצב העור.",
    afterTreatment:
      "ייתכן אודם קל שחולף תוך זמן קצר. מומלץ לשתות מים. חשוב לשמור על לחות העור. מומלץ להשתמש בהגנה מהשמש. התוצאה ממשיכה להשתפר בהדרגה גם לאחר הטיפול.",
    faq: [
      { q: "האם הטיפול כואב?", a: "ברוב המקרים לא. המטופלת מרגישה חימום נעים ומבוקר של העור." },
      { q: "מתי רואים תוצאה?", a: "ברוב המקרים ניתן לראות שינוי ראשוני כבר מהטיפול הראשון, והתוצאה משתפרת לאורך הסדרה." },
      { q: "כמה טיפולים מומלצים?", a: "לרוב 4–5 טיפולים." },
      { q: "האם הטיפול מחליף ניתוח?", a: "לא. זהו טיפול לא פולשני לשיפור מוצקות ומראה העור, אך אינו מחליף הליך כירורגי במקרים של רפיון משמעותי מאוד." },
    ],
    media: FACE_VIDEO,
    mediaType: 'video',
    price: "₪500",
    duration: "105 דק׳",
  },

  // ===================== ADVANCED & LASER =====================,
  {
    id: "exosomes-treatment",
    category: "advanced",
    title: "טיפול אקסוזומים לחידוש ושיקום העור",
    subtitle: "Exosomes Therapy",
    tagline: "טכנולוגיה ביולוגית מתקדמת להתחדשות תאי העור",
    description:
      "מהטיפולים החדשניים בתחום האסתטיקה — אקסוזומים מעבירים אותות תיקון בין תאי הגוף ומעודדים התחדשות עמוקה של העור.",
    paragraphs: [
      "טיפול אקסוזומים הוא מהטיפולים החדשניים ביותר בתחום האסתטיקה והאנטי־אייג'ינג. אקסוזומים הם חלקיקים ביולוגיים זעירים המסייעים בהעברת אותות תיקון בין תאי הגוף ובכך מעודדים תהליכי התחדשות טבעיים ושיקום עמוק של העור.",
      "הטיפול מתאים לעור עייף, בוגר, פגום או לאחר טיפולים אסתטיים.",
    ],
    benefits: [
      "האצת התחדשות תאים",
      "שיפור אלסטיות ומוצקות",
      "שיקום עור פגום",
      "הפחתת סימני גיל",
      "עידוד ייצור קולגן טבעי",
    ],
    suitableFor:
      "לעור עייף, בוגר, פגום, או כטיפול משלים לאחר הליכים אסתטיים.",
    beforeTreatment:
      "אין צורך בהכנה מיוחדת. מומלץ להגיע עם עור נקי ולעדכן את המטפלת על מצבי עור פעילים או טיפולים מקבילים.",
    afterTreatment:
      "ייתכן אדמומיות קלה הנעלמת תוך ימים ספורים. מומלץ להימנע מחשיפה לשמש בשבוע הראשון ולהשתמש בקרם הגנה SPF 50+.",
    faq: [
      { q: "מהם אקסוזומים?", a: "חלקיקים ביולוגיים זעירים המעבירים אותות תיקון בין תאי הגוף ומעודדים תהליכי התחדשות והבראה של העור." },
      { q: "האם הטיפול בטוח?", a: "כן — הטיפול נחשב בטוח ואינו כרוך בתופעות לוואי משמעותיות." },
      { q: "תוך כמה זמן רואים תוצאות?", a: "שיפור ראשוני נראה תוך מספר ימים. תוצאות עומק מתקבלות לאורך השבועות שלאחר הטיפול." },
      { q: "באיזו תדירות מומלץ?", a: "סדרה של 3–4 טיפולים בהפרשי זמן מותאמים, ולאחר מכן טיפול תחזוקה תקופתי." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: "₪900",
    duration: "105 דק׳",
  },
  {
    id: "pdrn-skin-repair",
    category: "advanced",
    title: "טיפול DNA סלמון לשיקום וחידוש העור",
    subtitle: "PDRN Skin Repair",
    tagline: "טיפול ביולוגי מתקדם לשיפור מרקם וחיוניות העור",
    description:
      "טיפול אסתטי מתקדם המבוסס על רכיב ביולוגי מ-DNA סלמון — שיקום והתחדשות תאי העור, שיפור לחות, מרקם וחיוניות.",
    paragraphs: [
      "טיפול DNA סלמון הוא טיפול אסתטי מתקדם המבוסס על רכיב ביולוגי המסייע בשיקום והתחדשות תאי העור. מדובר בטיפול אידיאלי לעור יבש, עייף, בוגר או פגום כתוצאה מנזקי שמש והזדקנות טבעית.",
      "הטיפול פועל לעידוד תהליכי תיקון טבעיים בעור, שיפור רמת הלחות וחיזוק מחסום ההגנה של העור.",
      "הערת מחיר: המחיר תלוי בסוג הטיפול.",
    ],
    benefits: [
      "שיפור לחות וגמישות",
      "חיזוק מחסום ההגנה של העור",
      "שיקום עור פגום",
      "שיפור מרקם וחיוניות",
      "מראה מלא ובריא יותר",
    ],
    suitableFor:
      "לעור יבש, עייף, בוגר או פגום מנזקי שמש והזדקנות טבעית.",
    beforeTreatment:
      "בחינת התאמה אישית של המקרה. יש לעדכן את המטפלת על תרופות, טיפולים מקבילים או רגישויות.",
    afterTreatment:
      "מומלץ להימנע מחשיפה לשמש, להשתמש בקרם הגנה SPF 50+ ולהקפיד על שגרת טיפוח עדינה.",
    faq: [
      { q: "מהו PDRN?", a: "רכיב ביולוגי המופק מ-DNA של דגי סלמון, התומך בשיקום רקמות ובהאצת ריפוי טבעי של העור." },
      { q: "למי הטיפול מתאים?", a: "לעור יבש, עייף, בוגר או פגום — וכן כטיפול משלים לאחר הליכים אסתטיים." },
      { q: "תוך כמה זמן רואים תוצאות?", a: "שיפור ראשוני נראה לאחר הטיפול הראשון. תוצאות עומק לאחר 2–3 טיפולים." },
      { q: "האם יש תופעות לוואי?", a: "הטיפול בטוח ועדין. ייתכן אדמומיות קלה זמנית הנעלמת תוך שעות ספורות." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: "₪300–₪1,100",
    duration: "105 דק׳",
  },
  {
    id: "co2-laser-peel",
    category: "advanced",
    title: "פילינג לייזר CO2 – חידוש עור מתקדם באמצעות טכנולוגיית Alma-Q",
    subtitle: null,
    tagline: null,
    description:
      "פילינג לייזר CO2 הוא אחד הטיפולים המתקדמים ביותר בתחום חידוש העור והאנטי־אייג'ינג. הטיפול מבוסס על טכנולוגיית לייזר מתקדמת היוצרת פגיעות מיקרוסקופיות מבוקרות בשכבות העמוקות של העור, במטרה לעורר את מנגנוני הריפוי הטבעיים של הגוף ולעודד ייצור מוגבר של קולגן ואלסטין.",
    paragraphs: [
      "התוצאה היא עור חלק יותר, אחיד יותר, מוצק יותר ובעל מראה צעיר ורענן לאורך זמן.",
      "בקליניקה של רהאם הטיפול מבוצע באמצעות מערכת Alma-Q המתקדמת, המאפשרת עבודה מדויקת ובטוחה תוך התאמה אישית מלאה לכל מטופלת.",
      "הטיפול מתבצע באמצעות מערכת Alma-Q המבוססת על טכנולוגיית Q-Switch פרקציונלית, המאפשרת עבודה מדויקת בשכבות העור השונות תוך יצירת גירוי מבוקר המוביל לתהליך חידוש עמוק. היתרון של הטכנולוגיה הוא היכולת לטפל בצורה ממוקדת תוך שמירה על בטיחות מקסימלית וזמן החלמה קצר יחסית.",
      "במהלך הטיפול קרני הלייזר יוצרות פגיעות מיקרוסקופיות מבוקרות בתוך שכבות העור. הגוף מזהה את הגירוי ומתחיל תהליך טבעי של תיקון והתחדשות, מייצר קולגן ואלסטין חדשים, מחדש תאי עור ומשפר את איכות הרקמה. התוצאה היא שיפור במרקם, צמצום צלקות, אחידות גוון ועור מוצק, חלק וזוהר יותר.",
      "הטיפול מתאים למגוון מטרות: שיפור צלקות אקנה באמצעות בנייה מחודשת של הרקמה והחלקת פני העור; טיפול בפיגמנטציה — כתמי שמש, כתמי גיל, פיגמנטציה הורמונלית וכתמים לאחר אקנה — לשיפור אחידות הגוון; וטיפול בקמטים וסימני גיל באמצעות עידוד יצירת קולגן חדש, טשטוש קמטוטים, שיפור גמישות והענקת מראה מוצק וצעיר יותר.",
      "מה שמייחד את הטיפול ברהאם: ניסיון מעולם הרפואה והקוסמטיקה, שילוב בין טכנולוגיה מתקדמת לרוקחות מותאמת אישית, התאמה מלאה לכל מטופלת, ליווי אישי לאורך כל התהליך, שימוש במערכת Alma-Q המתקדמת וראייה הוליסטית של בריאות העור והשיקום שלו.",
    ],
    benefits: [
      "חידוש עמוק של העור",
      "עידוד ייצור קולגן טבעי",
      "שיפור מראה קמטים וקמטוטים",
      "טיפול בצלקות אקנה",
      "שיפור פוסט אקנה",
      "הבהרת פיגמנטציה",
      "שיפור מרקם העור",
      "צמצום נקבוביות",
      "מיצוק והרמת עור",
      "תוצאות טבעיות ומצטברות",
      "זמן החלמה קצר יחסית",
      "מתאים לאזורים שונים בפנים ובגוף",
    ],
    suitableFor:
      "פיגמנטציה וכתמי שמש. כתמי גיל. צלקות אקנה. פוסט אקנה. קמטוטים וקמטים עדינים. נקבוביות מורחבות. עור עייף וחסר חיוניות. מרקם עור לא אחיד. סימני גיל מוקדמים. עור שאיבד מוצקות. מטופלות המעוניינות בחידוש עמוק של העור. מטופלות המעוניינות לעודד ייצור קולגן טבעי.",
    beforeTreatment:
      "יש להימנע מחשיפה מוגברת לשמש לפני הטיפול. יש להשתמש בקרם הגנה באופן קבוע. יש לעדכן על תרופות קבועות. יש לעדכן על טיפולים אסתטיים שבוצעו לאחרונה. יש להגיע עם עור נקי וללא איפור. יש לבצע אבחון מקצועי והתאמת פרוטוקול טיפול אישי.",
    afterTreatment:
      "ייתכן אודם קל או תחושת חום זמנית. חשוב להשתמש בקרם הגנה SPF 50. יש להימנע מחשיפה ישירה לשמש. יש להקפיד על לחות והרגעת העור. חשוב לעקוב אחר הנחיות הטיפול שניתנות בקליניקה. תהליך בניית הקולגן נמשך גם לאחר הטיפול ולכן התוצאות ממשיכות להשתפר לאורך זמן.",
    faq: [
      { q: "כמה זמן נמשך הטיפול?", a: "הטיפול אורך כשעה ו־40 דקות בממוצע, כולל הכנת העור, ביצוע הטיפול והנחיות להמשך טיפול ביתי." },
      { q: "האם הטיפול כואב?", a: "רוב המטופלות מתארות תחושת חום או עקצוץ קל במהלך הטיפול." },
      { q: "האם יש זמן החלמה?", a: "זמן ההחלמה קצר יחסית בהשוואה לטיפולי פילינג עמוקים מסורתיים." },
      { q: "האם רואים תוצאות כבר לאחר טיפול אחד?", a: "כן. בחלק מהמקרים ניתן לראות שיפור ראשוני כבר בשבועות הראשונים, אך התוצאות ממשיכות להשתפר במשך מספר חודשים." },
      { q: "כמה טיפולים מומלץ לבצע?", a: "מספר הטיפולים נקבע לאחר אבחון מקצועי בהתאם למצב העור ולמטרה הטיפולית." },
      { q: "האם הטיפול מתאים לכל סוגי העור?", a: "נדרש אבחון מקצועי לפני תחילת הטיפול כדי לוודא התאמה מלאה לסוג העור ולמצבו." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: null,
    duration: "75 דק׳",
  },
  {
    id: "laser-pigmentation-removal",
    category: "advanced",
    title: "לייזר להסרת פיגמנטציה",
    subtitle: null,
    tagline: null,
    description:
      "טיפול לייזר להסרת פיגמנטציה מיועד לטיפול בכתמים כהים, כתמי שמש, כתמי גיל, פיגמנטציה הורמונלית וכתמים שנוצרו לאחר אקנה או דלקת בעור.",
    paragraphs: [
      "הטיפול פועל על ריכוזי המלנין בעור. אנרגיית הלייזר מפרקת את הפיגמנט לחלקיקים קטנים, והגוף מפנה אותם בהדרגה בתהליך טבעי.",
      "זהו טיפול מדויק שמטרתו לשפר את אחידות גוון העור ולהעניק מראה נקי, בהיר ובריא יותר.",
      "תהליך טיפולי מומלץ: רואים תוצאה מהפירוק הראשון. מומלץ מינימום 3 טיפולים. מספר הטיפולים משתנה לפי עומק הפיגמנטציה, סוג הכתם, גוון העור ותגובת העור לטיפול.",
      "קריאה לפעולה: כתמים בעור? מתחילים לפרק אותם מהשורש",
    ],
    benefits: [
      "פירוק ממוקד של הפיגמנט",
      "שיפור אחידות גוון העור",
      "הפחתת כתמים קיימים",
      "טיפול מדויק באזור הבעיה",
      "תוצאה נראית כבר מהפירוק הראשון",
      "שיפור מראה העור הכללי",
    ],
    suitableFor:
      "למי שסובלת מכתמי שמש. למי שיש כתמי גיל. למי שסובלת מפיגמנטציה הורמונלית. למי שיש כתמים לאחר אקנה. למי שיש גוון עור לא אחיד. למי שרוצה הבהרה ממוקדת של אזורים כהים. למי שרוצה תוצאה מדויקת יותר מטיפול קוסמטי רגיל.",
    beforeTreatment:
      "אין להשתזף לפני הטיפול. יש להימנע מחשיפה לשמש. חשוב להשתמש בקרם הגנה לפני תחילת התהליך. יש לעדכן על תרופות, רגישויות או טיפולים קודמים באזור. יש להגיע עם עור נקי וללא איפור.",
    afterTreatment:
      "הכתם יכול להכהות זמנית לפני שהוא מתבהר. יש להקפיד על קרם הגנה SPF 50. יש להימנע מחשיפה ישירה לשמש. אין לגרד או לקלף את האזור. חשוב לשמור על לחות והרגעת העור. התוצאה נבנית בהדרגה בין טיפול לטיפול.",
    faq: [
      { q: "האם רואים תוצאה מהטיפול הראשון?", a: "כן, בדרך כלל ניתן לראות התחלה של פירוק הפיגמנט כבר לאחר הטיפול הראשון." },
      { q: "כמה טיפולים צריך?", a: "מינימום 3 טיפולים, ולעיתים יותר לפי עומק וסוג הפיגמנטציה." },
      { q: "האם הפיגמנטציה יכולה לחזור?", a: "כן, במיוחד אם יש חשיפה לשמש ללא הגנה, נטייה הורמונלית או חוסר שמירה על שגרת טיפול נכונה." },
      { q: "האם חייבים קרם הגנה?", a: "כן. קרם הגנה הוא חלק בלתי נפרד מהצלחת הטיפול." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: "₪450",
    duration: "75 דק׳",
  },
  {
    id: "laser-rf-acne-post-acne",
    category: "advanced",
    title: "טיפול באקנה ופוסט אקנה בשיטת לייזר וגלי רדיו",
    subtitle: null,
    tagline: null,
    description:
      "טיפול באקנה ופוסט אקנה בקליניקה משלב טכנולוגיה מתקדמת באמצעות ידית ייעודית הפועלת בטכנולוגיית גלי רדיו ואנרגיה מתקדמת, במטרה לטפל גם באקנה פעיל וגם בסימנים שנשארו לאחר אקנה.",
    paragraphs: [
      "גלי הרדיו יוצרים חימום מבוקר בשכבות העמוקות של העור. החימום מסייע להפחתת דלקת, איזון פעילות בלוטות החלב, שיפור תהליכי הריפוי הטבעיים של העור ועידוד ייצור קולגן חדש.",
      "הייחוד של השיטה הוא שהיא לא מתמקדת רק בפצע עצמו, אלא גם באיכות העור לאחר האקנה: סימנים אדומים, מרקם לא אחיד, נקבוביות מורחבות וצלקות קלות עד בינוניות.",
      "כיצד הטיפול עובד: ידית גלי הרדיו מחממת את שכבות העור בצורה מבוקרת. החימום מסייע בהפחתת פעילות יתר של בלוטות החלב. הטיפול מפחית דלקת פעילה בעור. הוא מעודד ריפוי טבעי של הרקמה. הוא מעודד ייצור קולגן חדש. הוא משפר את צפיפות ומרקם העור. הוא מסייע בטשטוש סימני אקנה וצלקות שטחיות.",
      "קריאה לפעולה: נמאס מפצעים וסימנים? מתחילים תהליך אמיתי לעור נקי יותר",
    ],
    benefits: [
      "טיפול באקנה פעיל",
      "טיפול בפוסט אקנה",
      "הפחתת דלקת ואדמומיות",
      "איזון שומניות העור",
      "שיפור מרקם העור",
      "צמצום מראה נקבוביות",
      "עידוד ייצור קולגן",
      "מתאים לפנים, גב וחזה",
      "ללא זמן החלמה ממושך",
      "ניתן לשלב עם רוקחות טבעית מותאמת אישית להמשך טיפול בבית",
    ],
    suitableFor:
      "למי שסובלת מאקנה פעיל בפנים. למי שסובל מאקנה בגב או בחזה. למי שיש פצעים דלקתיים. למי שיש עור שומני. למי שסובלת מנקבוביות מורחבות. למי שיש סימנים אדומים לאחר אקנה. למי שסובלת מפוסט אקנה. למי שיש צלקות אקנה קלות עד בינוניות. למי שניסתה טיפולים שונים ולא קיבלה תוצאה מספקת. למי שרוצה לשפר גם את הדלקת וגם את מרקם העור.",
    beforeTreatment:
      "יש להגיע עם עור נקי. יש לעדכן על תרופות לאקנה או טיפולים רפואיים. יש לעדכן על שימוש ברואקוטן בעבר או בהווה. יש להימנע מחשיפה מוגברת לשמש לפני הטיפול. חשוב לא לפוצץ פצעים לפני הטיפול. רהאם תבצע אבחון כדי להבין האם מדובר באקנה פעיל, פוסט אקנה או שילוב של שניהם.",
    afterTreatment:
      "ייתכן אודם קל למספר שעות. יש להשתמש בקרם הגנה SPF 50. יש להימנע מחומרים פעילים חזקים מספר ימים, לפי הנחיה. חשוב לשמור על ניקיון העור. לא מומלץ לגרד או ללחוץ על פצעים. מומלץ להמשיך שגרת טיפול ביתית מותאמת אישית כדי למנוע חזרה של האקנה.",
    faq: [
      { q: "האם הטיפול מתאים גם לאקנה פעיל וגם לפוסט אקנה?", a: "כן. היתרון של הטיפול הוא שהוא יכול לסייע גם בהפחתת דלקת פעילה וגם בשיפור הסימנים והמרקם שנשארו לאחר האקנה." },
      { q: "האם הטיפול כואב?", a: "ברוב המקרים מורגשת תחושת חום נסבלת ומבוקרת." },
      { q: "כמה טיפולים צריך?", a: "לרוב מומלצת סדרה של 4–8 טיפולים, בהתאם לחומרת האקנה והתגובה של העור." },
      { q: "מתי רואים תוצאות?", a: "שיפור בדלקת יכול להופיע כבר לאחר מספר טיפולים. שיפור בצלקות, מרקם וקולגן נבנה בהדרגה." },
      { q: "האם צריך גם טיפול בבית?", a: "ברוב המקרים כן. טיפול ביתי מותאם יכול לשפר משמעותית את התוצאה ולמנוע חזרה של פצעים." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: null,
    duration: "75 דק׳",
  },
  {
    id: "laser-tattoo-removal",
    category: "advanced",
    title: "לייזר להסרת קעקועים",
    subtitle: null,
    tagline: null,
    description:
      "טיפול לייזר להסרת קעקועים מיועד לפירוק חלקיקי הדיו שנמצאים בתוך העור. אנרגיית הלייזר פועלת על הפיגמנט של הקעקוע ומפרקת אותו לחלקיקים קטנים יותר, שהגוף מפנה בהדרגה בתהליך טבעי.",
    paragraphs: [
      "הטיפול מתאים להסרה מלאה או חלקית של קעקוע, וכן לטשטוש קעקוע לפני כיסוי חדש.",
      "גורמים המשפיעים על מספר הטיפולים: גודל הקעקוע, צבעי הקעקוע, עומק הדיו, גיל הקעקוע, סוג העור, האזור בגוף, תגובה אישית של הגוף לפינוי הפיגמנט",
      "הערת מחיר: בהתאם לגודל הקעקוע.",
      "קריאה לפעולה: רוצה להיפרד מקעקוע ישן? מתחילים בטשטוש מדויק",
    ],
    benefits: [
      "טיפול מדויק וממוקד",
      "אפשרות להסרה הדרגתית",
      "מתאים למגוון גדלים של קעקועים",
      "אפשרות לטשטוש לפני כיסוי",
      "טיפול מותאם לפי גודל וצבע הקעקוע",
    ],
    suitableFor:
      "למי שמעוניין להסיר קעקוע ישן. למי שמעוניין לטשטש קעקוע לפני קאבר. למי שיש קעקוע שהתיישן או דהה בצורה לא אחידה. למי שמתחרט על קעקוע קיים. למי שרוצה הסרה הדרגתית ובטוחה.",
    beforeTreatment:
      "יש להימנע מחשיפה לשמש לפני הטיפול. יש להגיע עם אזור נקי. חשוב לעדכן אם בוצעו טיפולים קודמים להסרת הקעקוע. חשוב לעדכן על רגישויות או נטייה לצלקות. יש לבצע אבחון לפני תחילת התהליך.",
    afterTreatment:
      "ייתכנו אדמומיות, רגישות או גלד באזור. אין לגרד את האזור. יש לשמור על האזור נקי. יש להימנע מחשיפה לשמש. יש להשתמש בהגנה מהשמש באזור המטופל. תהליך הפינוי של הדיו נמשך בהדרגה בין הטיפולים.",
    faq: [
      { q: "כמה טיפולים צריך?", a: "מספר הטיפולים משתנה לפי גודל הקעקוע, עומק הדיו, צבעים ותגובה אישית." },
      { q: "האם אפשר להסיר כל קעקוע?", a: "ברוב המקרים ניתן להשיג שיפור משמעותי, ולעיתים הסרה כמעט מלאה. התוצאה תלויה בסוג הקעקוע." },
      { q: "האם ניתן רק לטשטש לקראת קאבר?", a: "כן. ניתן לבצע טיפולים שמטרתם להבהיר את הקעקוע לפני כיסוי חדש." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: "₪300–₪500",
    duration: "75 דק׳",
  },
  {
    id: "laser-plasma-skin-tags",
    category: "advanced",
    title: "הסרת סרחי עור בשיטת לייזר ופלאזמה",
    subtitle: null,
    tagline: null,
    description:
      "סרחי עור הם בליטות עור קטנות ושפירות, שמופיעות לרוב באזור הצוואר, הפנים, המחשוף, בתי השחי ואזורים נוספים בגוף. למרות שלרוב אינם מסוכנים, הם יכולים להפריע אסתטית או לגרום לאי נוחות.",
    paragraphs: [
      "בקליניקה מתבצעת הסרת סרחי עור באמצעות לייזר ופלאזמה. מדובר בטיפול ממוקד, מהיר ומדויק, שמטרתו להסיר את הסרח בצורה נקייה ואסתטית.",
      "ברוב המקרים מספיק טיפול אחד.",
      "הערת מחיר: בהתאם לכמות ולגודל סרחי העור.",
      "קריאה לפעולה: סרחי עור מפריעים לך? טיפול קצר וממוקד לתוצאה נקייה",
    ],
    benefits: [
      "טיפול קצר ומהיר",
      "ברוב המקרים טיפול אחד בלבד",
      "דיוק גבוה",
      "ללא צורך בהליך כירורגי",
      "החלמה מהירה יחסית",
      "תוצאה אסתטית ונקייה",
    ],
    suitableFor:
      "למי שיש סרחי עור באזור הפנים. למי שיש סרחי עור בצוואר. למי שיש סרחי עור במחשוף. למי שיש סרחי עור בגוף. למי שסובל מאי נוחות אסתטית. למי שרוצה טיפול מהיר וממוקד.",
    beforeTreatment:
      "יש להגיע עם אזור נקי. יש לבצע בדיקה מקדימה להתאמת הטיפול. חשוב לעדכן על נטייה לצלקות, סוכרת, תרופות מדללות דם או מחלות עור. אין לבצע טיפול על נגעים חשודים ללא בדיקה רפואית מתאימה.",
    afterTreatment:
      "ייתכן אודם קל באזור. ייתכן גלד קטן שנושר לבד. אין לגרד או לקלף את האזור. יש להימנע מחשיפה לשמש. מומלץ להשתמש בקרם הגנה באזור חשוף. יש לשמור על האזור נקי לפי ההנחיות.",
    faq: [
      { q: "כמה טיפולים צריך?", a: "ברוב המקרים טיפול אחד בלבד." },
      { q: "האם נשאר סימן?", a: "בדרך כלל ההחלמה טובה, אך חשוב לשמור על ההנחיות ולא לגרד את האזור." },
      { q: "האם אפשר להסיר כל סרח עור?", a: "ברוב המקרים כן, אך נגעים חשודים דורשים בדיקה רפואית לפני טיפול." },
    ],
    media: ADV_VIDEO,
    mediaType: 'video',
    price: "₪150–₪250",
    duration: "75 דק׳",
  },
];

// Product imagery — RIHAM natural care line
const IMG_SHAMPOO = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/a.png?v=1778674112';
const IMG_SCALP_SHAMPOO = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/b.png?v=1778674112';
const IMG_HAIR_OIL = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/c.png?v=1778674111';
const IMG_FOOT_OIL = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/d.png?v=1778674111';
const IMG_HAIR_REDUCING_OIL =
  'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/33f0e9ad-731e-4500-82eb-2029cf72bb0c.png?v=1786991426';
const IMG_HAIR_MASK = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/e.png?v=1778674111';
const IMG_ANTI_AGING = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/f.png?v=1778674112';
const IMG_NIGHT_CREAM = 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/g.png?v=1778674112';

export type Product = {
  id: string;
  name: string;
  sub: string;
  tagline: string;
  description: string;
  longDescription: string[];
  benefits: string[];
  ingredients: string;
  usage: string;
  size: string;
  price: string;
  image: string;
  category: 'hair' | 'face' | 'body';
  faqs: { q: string; a: string }[];
};

export const productsData: Product[] = [
  {
    id: 'salt-free-shampoo',
    name: 'שמפו צמחי להחלקה',
    sub: 'Herbal Smoothing Shampoo',
    tagline: 'שמפו ללא מלחים לשיער רך, חלק ומלא לחות',
    description:
      'שמפו טבעי ללא מלחים המבוסס על צמחי מרפא ושמנים טבעיים המסייעים בריכוך השיער, שמירה על הלחות הטבעית והענקת מראה חלק, בריא ומבריק.',
    longDescription: [
      'שמפו צמחי להחלקה פותח במיוחד עבור שיער יבש, פגום, מקורזל או שיער שעבר החלקות וטיפולים כימיים. הפורמולה מבוססת על שילוב של שמנים טבעיים ותמציות צמחים המסייעים בניקוי יסודי ועדין מבלי לייבש את השיער או לפגוע באיזון הטבעי של הקרקפת.',
      'השמפו מעניק לשיער תחושת רכות וגמישות כבר מהשימוש הראשון, מסייע בהפחתת נפח וקצוות יבשים ומשאיר את השיער עם מראה בריא, מבריק ונעים למגע. בזכות העובדה שהוא ללא מלחים וללא רכיבים אגרסיביים, הוא מתאים במיוחד לאחר החלקות ושומר על תוצאות ההחלקה לאורך זמן.',
      'המוצר מיועד לשימוש יומיומי ומתאים לנשים וגברים המעוניינים בטיפוח טבעי ועדין לשיער.',
    ],
    benefits: [
      'ללא מלחים — שומר על תוצאות ההחלקה',
      'מתאים לאחר טיפולים כימיים',
      'מעניק רכות, גמישות וברק',
      'מפחית יובש וקצוות מפוצלים',
      'שומר על הלחות הטבעית של הקרקפת',
      'רכיבים טבעיים בלבד — ללא חומרים אגרסיביים',
    ],
    ingredients: 'שמנים טבעיים, תמציות צמחים, גומי ערבי ורכיבי הזנה טבעיים.',
    usage: 'יש להרטיב את השיער, למרוח כמות קטנה, לעסות בעדינות ולשטוף היטב. מתאים לשימוש יומיומי.',
    size: '500 מ״ל',
    price: '₪140',
    image: IMG_SHAMPOO,
    category: 'hair',
    faqs: [
      { q: 'האם השמפו מתאים לאחר החלקה?', a: 'כן. הפורמולה ללא מלחים ומתאימה במיוחד לשיער שעבר החלקות וטיפולים כימיים.' },
      { q: 'האם ניתן להשתמש בשמפו כל יום?', a: 'כן, השמפו עדין ומתאים לשימוש יומיומי.' },
      { q: 'האם השמפו מתאים גם לשיער יבש?', a: 'כן. הוא מסייע בהענקת לחות, ריכוך ושיקום מראה השיער.' },
      { q: 'האם המוצר מכיל חומרים אגרסיביים?', a: 'לא. המוצר מבוסס על רכיבים טבעיים וללא מלחים.' },
    ],
  },
  {
    id: 'scalp-balance-shampoo',
    name: 'שמפו לאיזון הקרקפת',
    sub: 'Scalp Balance Shampoo',
    tagline: 'לטיפול בקשקשים, גירויים ושיער חלש',
    description:
      'שמפו טיפולי המבוסס על צמחי מרפא ושמנים טבעיים המסייעים להפחתת קשקשים, איזון הקרקפת וחיזוק שורשי השיער.',
    longDescription: [
      'שמפו לאיזון הקרקפת נועד להעניק טיפול טבעי ועדין לקרקפת הסובלת מקשקשים, גירויים, יובש או שומניות יתר. הפורמולה משלבת תמציות צמחים ושמנים טבעיים הידועים ביכולתם להרגיע את עור הקרקפת, לנקות בעדינות ולהעניק תחושת רעננות לאורך זמן.',
      'השמפו מסייע בהפחתת קשקשים ובהרגעת תחושת גירוי או אי נוחות בקרקפת, תוך תמיכה בחיזוק שורשי השיער וצמיחה בריאה יותר. הוא מתאים לשימוש קבוע ואינו מכיל חומרים אגרסיביים העלולים לגרום ליובש או רגישות.',
      'השימוש הקבוע בשמפו מסייע לשמור על קרקפת מאוזנת ונקייה ועל שיער בריא, חזק ורענן יותר.',
    ],
    benefits: [
      'מסייע בהפחתת קשקשים',
      'מאזן את הקרקפת',
      'מעניק תחושת ניקיון ורעננות',
      'מסייע בחיזוק שורשי השיער',
      'מתאים לקרקפת רגישה',
      'ללא כימיקלים קשים',
    ],
    ingredients: 'תמציות צמחים טבעיות, שמנים טיפוליים ורכיבי הזנה לקרקפת.',
    usage: 'יש למרוח על קרקפת רטובה, לעסות בעדינות במשך דקה ולשטוף. מתאים לשימוש קבוע 2–3 פעמים בשבוע.',
    size: '500 מ״ל',
    price: '₪150',
    image: IMG_SCALP_SHAMPOO,
    category: 'hair',
    faqs: [
      { q: 'האם השמפו מתאים לקרקפת רגישה?', a: 'כן. הפורמולה פותחה במיוחד לקרקפת הזקוקה לטיפול עדין ואיזון.' },
      { q: 'האם השמפו עוזר לקשקשים?', a: 'השמפו מסייע בהפחתת קשקשים ובהרגעת תחושת גירוי ויובש בקרקפת.' },
      { q: 'תוך כמה זמן רואים שינוי?', a: 'השימוש הקבוע מסייע לשיפור מראה הקרקפת והשיער לאורך הזמן.' },
      { q: 'האם ניתן לשלב עם שמנים או מסכות?', a: 'כן. ניתן לשלב כחלק משגרת טיפוח מלאה לשיער ולקרקפת.' },
    ],
  },
  {
    id: 'hair-growth-oil',
    name: 'שמן קרקפת לחיזוק השיער',
    sub: 'Scalp & Growth Oil',
    tagline: 'טיפול טבעי להפחתת נשירה ודלילות',
    description:
      'שמן טבעי לקרקפת המסייע בחיזוק שורשי השיער, צמיחה טבעית והפחתת נשירה, דלילות וקשקשים.',
    longDescription: [
      'שמן הקרקפת של RIHAM מבוסס על שילוב עוצמתי של שמן קיק, שמן ציפורן ותערובת של צמחי מרפא ושמנים טבעיים שנבחרו בקפידה לטיפול בקרקפת ובשיער חלש או דליל.',
      'הפורמולה חודרת לעומק הקרקפת ומסייעת בהזנת שורשי השיער, חיזוק סיב השערה והפחתת נשירה. בנוסף, השמן מסייע בהרגעת הקרקפת ובהפחתת קשקשים ותחושת יובש.',
      'השימוש הקבוע בשמן מעניק לקרקפת הזנה עמוקה ותומך במראה שיער מלא, בריא וחזק יותר. מתאים לשימוש יומיומי או מספר פעמים בשבוע כחלק משגרת טיפוח טבעית.',
    ],
    benefits: [
      'מסייע בצמיחת שיער',
      'מפחית נשירה ודלילות',
      'מחזק את שורשי השיער',
      'מסייע בהרגעת הקרקפת',
      'מסייע נגד קשקשים',
      'מעניק הזנה עמוקה לשיער',
    ],
    ingredients: 'שמן קיק, שמן ציפורן, תמציות צמחים ושמנים טבעיים.',
    usage: 'יש לטפטף מספר טיפות על הקרקפת ולעסות בעדינות. ניתן להשאיר ללילה או לשטוף לאחר שעה.',
    size: '30 מ״ל',
    price: '₪180',
    image: IMG_HAIR_OIL,
    category: 'hair',
    faqs: [
      { q: 'איך משתמשים בשמן?', a: 'יש לטפטף מספר טיפות על הקרקפת ולעסות בעדינות.' },
      { q: 'כמה פעמים בשבוע מומלץ להשתמש?', a: 'ניתן להשתמש מספר פעמים בשבוע בהתאם לצורך.' },
      { q: 'האם השמן מתאים גם לשיער דליל?', a: 'כן. הפורמולה פותחה במיוחד להזנת הקרקפת וחיזוק שיער חלש או דליל.' },
      { q: 'האם השמן שומני מאוד?', a: 'השמן עשיר אך נספג היטב כאשר משתמשים בכמות מתאימה.' },
    ],
  },
  {
    id: 'foot-care-oil',
    name: 'שמן טיפוח לכפות הרגליים',
    sub: 'Foot Care Oil',
    tagline: 'טיפול טבעי לעור יבש, סדוק ובעייתי',
    description:
      'שמן טבעי לכפות הרגליים המבוסס על שמנים וצמחי מרפא המסייעים בריכוך עור יבש, הזנת העור ושיפור מראה כפות הרגליים.',
    longDescription: [
      'שמן טיפוח לכפות הרגליים של RIHAM פותח במיוחד לטיפול והזנה של עור יבש, מחוספס או סדוק בכפות הרגליים. הפורמולה משלבת שמנים טבעיים וצמחי מרפא הידועים בתכונות ההזנה, הריכוך והטיפוח שלהם.',
      'השמן נספג בקלות ומעניק לעור תחושת רכות, לחות וגמישות מבלי להשאיר תחושה כבדה. הוא מתאים במיוחד לאנשים הסובלים מיובש, עור מחוספס או תחושת אי נוחות בכפות הרגליים בעקבות עמידה ממושכת, מזג אוויר יבש או חוסר לחות.',
      'השימוש הקבוע בשמן מסייע בשיפור מראה העור, מעניק תחושת רעננות ותורם לשגרת טיפוח טבעית ובריאה לכפות הרגליים.',
    ],
    benefits: [
      'מסייע בריכוך עור יבש וסדוק',
      'מעניק לחות והזנה עמוקה',
      'מתאים לטיפוח יומיומי',
      'נספג במהירות',
      'מעניק תחושת רכות וגמישות',
      'מבוסס על רכיבים טבעיים בלבד',
    ],
    ingredients: 'שמנים טבעיים, תמציות צמחים ורכיבי הזנה טבעיים לכפות הרגליים.',
    usage: 'יש למרוח כמות קטנה על כפות הרגליים, לעסות בעדינות עד לספיגה. מומלץ לפני השינה.',
    size: '30 מ״ל',
    price: '₪140',
    image: IMG_FOOT_OIL,
    category: 'body',
    faqs: [
      { q: 'למי מתאים השמן?', a: 'המוצר מתאים לאנשים הסובלים מעור יבש, מחוספס או סדוק בכפות הרגליים.' },
      { q: 'מתי מומלץ להשתמש?', a: 'מומלץ למרוח לפני השינה לקבלת ספיגה מיטבית.' },
      { q: 'האם השמן שומני?', a: 'השמן נספג היטב ואינו משאיר תחושה כבדה.' },
      { q: 'האם המוצר מבוסס על רכיבים טבעיים?', a: 'כן. השמן מבוסס על שמנים וצמחי מרפא טבעיים בלבד.' },
    ],
  },
  {
    id: 'hair-reducing-oil',
    name: 'שמן טבעי להפחתת קצב צמיחת השיער',
    sub: 'Hair Growth Reducing Oil',
    tagline: 'רוקחות טבעית מצמחים ערביים — עור חלק לאורך זמן',
    description:
      'שמן ייחודי שפותח ונרקח בקליניקה של רהאם מנסור, המשלב צמחי מרפא ערביים, שמנים צמחיים ורכיבים טבעיים איכותיים. מיועד לשימוש לאחר הסרת שיער — מסייע בהפחתת קצב צמיחת השיער, מרגיע את העור ומעניק לו לחות.',
    longDescription: [
      'שמן ייחודי שפותח ונרקח בקליניקה של רהאם מנסור, המבוסס על שילוב של צמחי מרפא ערביים, שמנים צמחיים ורכיבים טבעיים איכותיים שנבחרו בקפידה. המוצר מיועד לשימוש לאחר הסרת שיער, במטרה לסייע בהפחתת קצב צמיחת השיער, להרגיע את העור, להעניק לו לחות ולשמור על מראה חלק לאורך זמן. השמן פועל בצורה טבעית ועדינה ומתאים לשימוש יומיומי כחלק משגרת הטיפוח לאחר הסרת השיער.',
      'כיצד פועל השמן? לאחר הסרת השיער, העור וזקיקי השערה קולטים בצורה טובה יותר את הרכיבים הפעילים. השימוש היומיומי בשמן מאפשר לרכיבים הצמחיים לפעול באזור זקיק השערה ולסייע בהאטת קצב הצמיחה לאורך זמן. בנוסף, השמן מסייע בהרגעת העור לאחר הסרת שיער, מעניק לחות, מפחית תחושת יובש ומשאיר את העור רך, נעים ובריא יותר.',
      'הרכיב הפעיל המרכזי: הפורמולה מכילה שמן גומא הפקעים (Cyperus rotundus) – צמח מרפא מסורתי שנחקר בהקשר של הפחתת קצב צמיחת שיער לאחר הסרתו, ומשולב יחד עם רכיבים צמחיים נוספים שנבחרו בקפידה כחלק מתהליך הרוקחות הטבעית של רהאם.',
      'למי מתאים המוצר? נשים וגברים, כל סוגי העור וכל סוגי השיער, פנים (למעט אזור העיניים) וגוף, כולל עור רגיש. אידיאלי לשימוש לאחר לייזר להסרת שיער, שעווה, אפילציה, גילוח, חוט ומכשירי הסרת שיער ביתיים.',
      'מה חשוב לדעת? המוצר מיועד לשימוש חיצוני בלבד. מומלץ לבצע בדיקת רגישות על אזור קטן לפני השימוש הראשון ואין להשתמש על עור פצוע, מגורה או מודלק. אין למרוח באזור העיניים, הריסים והגבות. במקרה של גירוי יש להפסיק את השימוש ולהרחיק מהישג ידם של ילדים.',
      'מה חשוב לדעת במהלך השימוש? מומלץ להשתמש במוצר מדי יום, אין צורך לשטוף את האזור לאחר המריחה, וניתן לשלב את השמן כחלק משגרת הטיפוח לאחר לייזר, שעווה, גילוח או אפילציה. לקבלת תוצאות מיטביות מומלץ להשתמש באופן רציף לאורך מספר שבועות.',
    ],
    benefits: [
      '100% רכיבים טבעיים',
      'רוקחות טבעית מצמחים ערביים',
      'מסייע בהפחתת קצב צמיחת השיער',
      'מסייע לשמור על עור חלק לאורך זמן',
      'מרגיע את העור לאחר הסרת שיער',
      'מעניק לחות והזנה לעור',
      'נספג במהירות ואינו משאיר תחושת שומניות',
      'מתאים לנשים ולגברים',
      'מתאים לכל סוגי העור ולכל סוגי השיער',
      'ללא חומרים כימיים אגרסיביים',
      'נרקח בקליניקה של רהאם מנסור',
      'אידיאלי לאחר לייזר, שעווה, גילוח ואפילציה',
    ],
    ingredients:
      'שמן גומא הפקעים (Cyperus rotundus), תמציות צמחי מרפא ערביים, שמנים צמחיים ורכיבים טבעיים איכותיים. 100% רכיבים טבעיים, ללא חומרים כימיים אגרסיביים.',
    usage:
      'לטפטף 2 טיפות על האזור לאחר הסרת השיער ולעסות בעדינות עד לספיגה מלאה. לשימוש פעם ביום, באופן קבוע, לקבלת התוצאה הטובה ביותר. אין צורך לשטוף את האזור לאחר המריחה. לשימוש חיצוני בלבד.',
    size: '30 מ״ל',
    price: '₪140',
    image: IMG_HAIR_REDUCING_OIL,
    category: 'body',
    faqs: [
      {
        q: 'האם השמן מסיר את השיער?',
        a: 'לא. השמן אינו מסיר את השיער ואינו מהווה תחליף להסרת שיער. הוא מיועד לשימוש לאחר הסרת השיער, במטרה לסייע בהפחתת קצב הצמיחה לאורך זמן.',
      },
      {
        q: 'האם השמן מתאים לאחר לייזר?',
        a: 'כן. השמן מתאים לשימוש לאחר טיפולי לייזר להסרת שיער, בהתאם להנחיות המטפל ולאחר שהעור נרגע.',
      },
      {
        q: 'האם אפשר להשתמש לאחר שעווה או גילוח?',
        a: 'בהחלט. השמן מתאים לשימוש לאחר שעווה, גילוח, אפילציה, חוט ומכשירי הסרת שיער ביתיים.',
      },
      {
        q: 'האם המוצר מתאים לכל סוגי העור?',
        a: 'כן. המוצר מבוסס על רכיבים טבעיים ומתאים לרוב סוגי העור, כולל עור רגיש. עם זאת, מומלץ לבצע בדיקת רגישות לפני השימוש הראשון.',
      },
      { q: 'האם מתאים גם לגברים?', a: 'כן. המוצר מתאים לנשים ולגברים כאחד.' },
      {
        q: 'כמה זמן צריך להשתמש?',
        a: 'לקבלת התוצאה הטובה ביותר מומלץ להשתמש מדי יום ובהתמדה כחלק משגרת הטיפוח לאחר הסרת השיער.',
      },
      {
        q: 'מתי מתחילים לראות תוצאות?',
        a: 'משך הזמן משתנה בין אדם לאדם ותלוי בגורמים כמו סוג השיער, אזור הטיפול, שיטת הסרת השיער והתמדה בשימוש.',
      },
      {
        q: 'האם אפשר להשתמש בכל אזורי הגוף?',
        a: 'כן. המוצר מתאים לרוב אזורי הגוף והפנים, למעט אזור העיניים, הריסים והגבות.',
      },
    ],
  },

  {
    id: 'hair-repair-mask',
    name: 'מסכת שיער טבעית לשיקום',
    sub: 'Intensive Repair Mask',
    tagline: 'הזנה עמוקה, שיקום וברק לשיער פגום',
    description:
      'מסכת שיער עשירה ומזינה המבוססת על חמאות טבעיות, שמנים וצמחי מרפא לשיקום שיער יבש, פגום או חלש.',
    longDescription: [
      'מסכת השיער של RIHAM פותחה במיוחד לשיער הזקוק להזנה עמוקה ושיקום אינטנסיבי. הפורמולה משלבת חמאות טבעיות, שמנים איכותיים ותמציות צמחים המסייעים בריכוך השיער, שיפור מראה הקצוות והענקת מראה בריא ומבריק.',
      'המסכה מסייעת בהחזרת לחות לשיער יבש, מקלה על הסירוק ומעניקה תחושת רכות וגמישות. היא מתאימה במיוחד לשיער שעבר טיפולים כימיים, החלקות או צביעות חוזרות.',
      'השימוש הקבוע במסכה מעניק לשיער מראה מטופח, חזק ומלא חיוניות לאורך זמן.',
    ],
    benefits: [
      'מסייעת בשיקום שיער פגום',
      'מעניקה הזנה עמוקה',
      'מסייעת בריכוך וגמישות',
      'מתאימה לשיער צבוע ומוחלק',
      'מעניקה ברק ומראה בריא',
      'מבוססת על רכיבים טבעיים',
    ],
    ingredients: 'חמאות טבעיות, שמנים איכותיים, תמציות צמחים ורכיבי הזנה.',
    usage: 'יש למרוח על שיער נקי ולח, להשאיר 30 דקות ולשטוף היטב. מומלץ פעמיים בשבוע.',
    size: '200 מ״ל',
    price: '₪220',
    image: IMG_HAIR_MASK,
    category: 'hair',
    faqs: [
      { q: 'כמה פעמים בשבוע להשתמש?', a: 'מומלץ להשתמש פעמיים בשבוע לקבלת תוצאות מיטביות.' },
      { q: 'כמה זמן להשאיר על השיער?', a: 'מומלץ להשאיר לפחות 30 דקות לאחר מקלחת חמה.' },
      { q: 'האם המסכה מתאימה לשיער צבוע?', a: 'כן. המסכה מתאימה גם לשיער צבוע או פגום.' },
      { q: 'האם המסכה מכבידה על השיער?', a: 'לא. היא מעניקה הזנה עמוקה תוך שמירה על תחושת רכות טבעית.' },
    ],
  },
  {
    id: 'anti-aging-cream',
    name: 'קרם פנים אנטי אייג׳ינג',
    sub: 'Anti-Aging Face Cream',
    tagline: 'להזנה, מיצוק ולחות עמוקה',
    description:
      'קרם אנטי אייג׳ינג טבעי המבוסס על חמאת מנגו, גומי ערבי ושמנים טבעיים להזנת העור, שיפור האלסטיות והענקת לחות עמוקה.',
    longDescription: [
      'קרם הפנים האנטי אייג׳ינג של RIHAM פותח במטרה להעניק לעור הפנים הזנה עמוקה, לחות גבוהה ומראה צעיר ורענן יותר. הפורמולה מבוססת על שילוב עשיר של חמאת מנגו, גומי ערבי ותערובת שמנים טבעיים המסייעים בשיפור מראה העור ובהענקת תחושת רכות וגמישות.',
      'הקרם מסייע בטשטוש מראה קמטים וקמטוטים, מעניק לעור מראה חלק וזוהר ותומך בהתחדשות הטבעית של העור. גומי ערבי ידוע ביכולתו לסייע בשמירה על לחות ולהעניק תחושת מיצוק והחלקה.',
      'המרקם העשיר נספג בנעימות ומתאים לשימוש יומיומי כחלק משגרת טיפוח טבעית ואיכותית.',
    ],
    benefits: [
      'מסייע בהפחתת קמטים',
      'מעניק לחות עמוקה',
      'מסייע בשיפור גמישות העור',
      'תומך במראה עור חלק וזוהר',
      'מסייע בתחושת מיצוק טבעית',
      'מבוסס על רכיבים טבעיים בלבד',
    ],
    ingredients: 'חמאת מנגו, גומי ערבי, שמנים טבעיים ותמציות צמחים.',
    usage: 'יש למרוח כמות קטנה על עור נקי בבוקר ובערב, לעסות עד לספיגה.',
    size: '50 מ״ל',
    price: '₪280',
    image: IMG_ANTI_AGING,
    category: 'face',
    faqs: [
      { q: 'האם הקרם מתאים לשימוש יומיומי?', a: 'כן. הקרם מתאים לשימוש כחלק משגרת טיפוח יומיומית.' },
      { q: 'האם הקרם מתאים לכל סוגי העור?', a: 'הפורמולה מתאימה לרוב סוגי העור ומעניקה לחות עמוקה.' },
      { q: 'האם הקרם שומני?', a: 'המרקם עשיר אך נספג בנעימות ואינו מכביד על העור.' },
      { q: 'מה היתרון של גומי ערבי בקרם?', a: 'גומי ערבי מסייע בשמירה על לחות ובהענקת תחושת מיצוק והחלקה לעור.' },
    ],
  },
  {
    id: 'night-renewal-cream',
    name: 'קרם לילה להבהרה וחידוש העור',
    sub: 'Night Renewal Cream',
    tagline: 'לטיפול בפיגמנטציה והענקת זוהר טבעי',
    description:
      'קרם לילה טבעי המסייע באחידות גוון העור, הפחתת פיגמנטציה והענקת מראה חיוני, חלק וזוהר.',
    longDescription: [
      'קרם הלילה של RIHAM פותח במיוחד לטיפוח והזנת עור הפנים בזמן מנוחת הלילה. הפורמולה משלבת חמאות טבעיות, שמנים איכותיים וגומי ערבי המסייעים בשיפור מראה העור ובהענקת תחושת לחות ורכות לאורך זמן.',
      'הקרם מסייע בטשטוש מראה פיגמנטציה, תומך באחידות גוון העור ומעניק לעור מראה בריא, קורן ורענן יותר. המרקם העשיר נספג בנעימות ומסייע בהזנה עמוקה של העור מבלי להכביד.',
      'המוצר אינו מכיל חומרים משמרים או רכיבים אגרסיביים ומתאים לאנשים המחפשים טיפוח טבעי ועדין.',
    ],
    benefits: [
      'מסייע בהפחתת פיגמנטציה',
      'מעניק לחות עמוקה',
      'מסייע באחידות גוון העור',
      'מעניק מראה זוהר ורענן',
      'תומך בהתחדשות טבעית של העור',
      'ללא חומרים משמרים',
    ],
    ingredients: 'חמאות טבעיות, גומי ערבי, שמנים צמחיים ותמציות טבעיות.',
    usage: 'יש למרוח בערב על עור נקי כחלק משגרת טיפוח הלילה.',
    size: '50 מ״ל',
    price: '₪260',
    image: IMG_NIGHT_CREAM,
    category: 'face',
    faqs: [
      { q: 'מתי מומלץ להשתמש בקרם?', a: 'מומלץ להשתמש בערב על עור נקי כחלק משגרת הלילה.' },
      { q: 'האם הקרם מתאים לפיגמנטציה?', a: 'הקרם פותח במיוחד לסיוע באחידות גוון העור ושיפור מראה פיגמנטציה.' },
      { q: 'האם הקרם מעניק לחות?', a: 'כן. הפורמולה מעניקה לחות עמוקה והזנה לעור.' },
      { q: 'האם הקרם מכיל חומרים משמרים?', a: 'לא. המוצר מבוסס על רכיבים טבעיים בלבד.' },
    ],
  },
];

// Curated product bundles
export const bundlesData = [
  {
    id: 'skin-glow-set',
    name: 'מארז זוהר והתחדשות לעור',
    sub: 'Skin Glow & Renewal',
    tagline: 'הבהרה, חידוש ומיצוק',
    description:
      'דואט פנים יומיומי — קרם לילה להבהרה וחידוש העור יחד עם קרם אנטי אייג׳ינג עוצמתי למראה זוהר וצעיר.',
    productIds: ['night-renewal-cream', 'anti-aging-cream'],
    discount: 0.12,
    image: IMG_NIGHT_CREAM,
    category: 'face',
  },
  {
    id: 'hair-growth-set',
    name: 'מארז חיזוק וצמיחת שיער',
    sub: 'Hair Strength & Growth',
    tagline: 'חיזוק שורשים וצמיחה טבעית',
    description:
      'שמפו צמחי טבעי לשיער יחד עם שמן טבעי לקרקפת ולשיער — שגרה לחיזוק, הזנה וצמיחה בריאה.',
    productIds: ['salt-free-shampoo', 'hair-growth-oil'],
    discount: 0.12,
    image: IMG_HAIR_OIL,
    category: 'hair',
  },
  {
    id: 'hair-repair-set',
    name: 'מארז שיקום אינטנסיבי לשיער',
    sub: 'Intensive Hair Repair',
    tagline: 'ניקוי, הזנה ושיקום עמוק',
    description:
      'שגרה מלאה לשיער פגום או יבש — שמפו צמחי טבעי, שמן לקרקפת ולשיער ומסיכת שיער בוטנית משקמת.',
    productIds: ['salt-free-shampoo', 'hair-growth-oil', 'hair-repair-mask'],
    discount: 0.15,
    image: IMG_HAIR_MASK,
    category: 'hair',
  },
];

// Per-product recommended products (shown on product detail page)
export const productRecommendations: Record<string, string[]> = {
  'night-renewal-cream': ['anti-aging-cream'],
  'anti-aging-cream': ['night-renewal-cream'],
  'salt-free-shampoo': ['hair-growth-oil', 'hair-repair-mask'],
  'scalp-balance-shampoo': ['hair-growth-oil'],
  'hair-growth-oil': ['salt-free-shampoo', 'hair-repair-mask'],
  'hair-repair-mask': ['salt-free-shampoo', 'hair-growth-oil'],
  'foot-care-oil': [],
};


// Shop categories with hero videos
export const shopCategories: {
  id: string;
  number: string;
  label: string;
  subtitle: string;
  desc: string;
  media: string;
  mediaType: 'video' | 'image';
}[] = [
  {
    id: 'hair',
    number: '01',
    label: 'שיער וקרקפת',
    subtitle: 'Hair & Scalp',
    desc: 'פורמולות צמחיות לחיזוק, איזון והחייאה — שמפו, שמנים ומסכות שנרקחו בעבודת יד.',
    media: HAIR_VIDEO,
    mediaType: 'video',
  },
  {
    id: 'face',
    number: '02',
    label: 'טיפוח הפנים',
    subtitle: 'Face Care',
    desc: 'טקסטורות עשירות, רכיבים פעילים מהטבע — קרמים יומיומיים שמחזירים לעור את הזוהר הטבעי.',
    media: FACE_VIDEO,
    mediaType: 'video',
  },
  {
    id: 'body',
    number: '03',
    label: 'גוף וטיפוח עדין',
    subtitle: 'Body & Care',
    desc: 'פתרונות טבעיים נקודתיים לעור הידיים, הרגליים והציפורניים — לשימוש יומיומי עדין ויעיל.',
    media: ADV_VIDEO,
    mediaType: 'video',
  },
];

// Service categories — single source of truth for /admin services, the
// Appointment widget, and the Shopify item editor (services).
// `id` matches the slug stored in Shopify as `service-category-<id>` tag.
export const serviceCategories: { id: string; label: string; subtitle: string }[] = [
  { id: 'hair', label: 'שיער וקרקפת', subtitle: 'Hair & Scalp' },
  { id: 'face', label: 'טיפולי פנים', subtitle: 'Face Care' },
  { id: 'advanced', label: 'אסתטיקה מתקדמת', subtitle: 'Advanced Aesthetics' },
];
